import { validateConfig } from './config-validation';
export { validateConfig, envNames } from './config-validation';
export const configIssues = validateConfig(import.meta.env, { production: import.meta.env.PROD, runtimeUrl: window.location.href });
export const config = {
  apiUrl: import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, ''),
  domain: import.meta.env.VITE_COGNITO_DOMAIN?.replace(/\/$/, ''),
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  authority: `https://cognito-idp.${import.meta.env.VITE_AWS_REGION}.amazonaws.com/${import.meta.env.VITE_COGNITO_USER_POOL_ID}`,
  redirectUri: import.meta.env.VITE_COGNITO_REDIRECT_URI,
  logoutUri: import.meta.env.VITE_COGNITO_LOGOUT_URI,
};
